export const environment = {
  name: 'staging',
  production: false,
  productType: 'web-app',
  token_auth_config: {
    apiBase: 'https://api.staging.europe.inyova.cloud',
    apiPath: 'api/v2/customers'
  },
  apiUrl: 'https://api.staging.europe.inyova.cloud/api/v2/customers',
  apiUrlV3: 'https://api.staging.europe.inyova.cloud/api/v3',
  apiUrlV4: 'https://api.staging.europe.inyova.cloud/api/v4',
  googleApiAppId: '200006176293-gkummghsmt49j81oi9nnluae4ttoucjn.apps.googleusercontent.com',
  ipGeolocationApiKey: '4cf102d6c34a8644690288f0e272e6ec89e4589c5a4136dce47297a4',
  amplitudeApiKey: '3a9b51c86d614e44369f3e2b8e78e026',
  reCaptchaSiteKey: '6LeajUgtAAAAAEKoMODFhAC16SV7Rk_5E65BjN7V',
  logoURL: '/assets/images/inyova-logo-new.svg',
  I4KlogoURL: '/assets/images/i4k-logo.svg',
  theme: 'inyova'
};
